module.exports = __webpack_public_path__ + "static/media/skills-concept-skills-education-learning-personal-development-competency-business-min.d30900b7.jpg";